import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderBillingClaims: build.query<
      GetV2ProviderBillingClaimsApiResponse,
      GetV2ProviderBillingClaimsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/claims`,
        params: {
          patient_id: queryArg.patientId,
          provider_ids: queryArg.providerIds,
          status: queryArg.status,
          payer_uuid: queryArg.payerUuid,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          submission_date_from: queryArg.submissionDateFrom,
          submission_date_to: queryArg.submissionDateTo,
          charge_min: queryArg.chargeMin,
          charge_max: queryArg.chargeMax,
          balance_min: queryArg.balanceMin,
          balance_max: queryArg.balanceMax,
          source_system: queryArg.sourceSystem,
          claim_type: queryArg.claimType,
          queue: queryArg.queue,
          include_superseded: queryArg.includeSuperseded,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderBillingClaimsQueueCounts: build.query<
      GetV2ProviderBillingClaimsQueueCountsApiResponse,
      GetV2ProviderBillingClaimsQueueCountsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/claims/queue-counts`,
        params: {
          patient_id: queryArg.patientId,
          provider_ids: queryArg.providerIds,
          status: queryArg.status,
          payer_uuid: queryArg.payerUuid,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          submission_date_from: queryArg.submissionDateFrom,
          submission_date_to: queryArg.submissionDateTo,
          charge_min: queryArg.chargeMin,
          charge_max: queryArg.chargeMax,
          balance_min: queryArg.balanceMin,
          balance_max: queryArg.balanceMax,
          source_system: queryArg.sourceSystem,
          claim_type: queryArg.claimType,
          queue: queryArg.queue,
          include_superseded: queryArg.includeSuperseded,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderBillingClaimsByClaimId: build.query<
      GetV2ProviderBillingClaimsByClaimIdApiResponse,
      GetV2ProviderBillingClaimsByClaimIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/claims/${queryArg.claimId}`,
      }),
    }),
    getV2ProviderClaims: build.query<
      GetV2ProviderClaimsApiResponse,
      GetV2ProviderClaimsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/claims`,
        params: {
          patient_id: queryArg.patientId,
          status: queryArg.status,
          payer_uuid: queryArg.payerUuid,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          page: queryArg.page,
          page_size: queryArg.pageSize,
        },
      }),
    }),
    postV2ProviderClaims: build.mutation<
      PostV2ProviderClaimsApiResponse,
      PostV2ProviderClaimsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/claims`,
        method: "POST",
        body: queryArg.createClaimRequest,
      }),
    }),
    postV2ProviderClaimsBatchSubmit: build.mutation<
      PostV2ProviderClaimsBatchSubmitApiResponse,
      PostV2ProviderClaimsBatchSubmitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/claims/batch-submit`,
        method: "POST",
        body: queryArg.batchSubmitClaimsRequest,
      }),
    }),
    deleteV2ProviderClaimsByClaimId: build.mutation<
      DeleteV2ProviderClaimsByClaimIdApiResponse,
      DeleteV2ProviderClaimsByClaimIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/claims/${queryArg.claimId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderClaimsByClaimId: build.query<
      GetV2ProviderClaimsByClaimIdApiResponse,
      GetV2ProviderClaimsByClaimIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/provider/claims/${queryArg.claimId}` }),
    }),
    putV2ProviderClaimsByClaimId: build.mutation<
      PutV2ProviderClaimsByClaimIdApiResponse,
      PutV2ProviderClaimsByClaimIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/claims/${queryArg.claimId}`,
        method: "PUT",
        body: queryArg.updateClaimRequest,
      }),
    }),
    postV2ProviderClaimsByClaimIdAttention: build.mutation<
      PostV2ProviderClaimsByClaimIdAttentionApiResponse,
      PostV2ProviderClaimsByClaimIdAttentionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/claims/${queryArg.claimId}/attention`,
        method: "POST",
        body: queryArg.claimAttentionRequest,
      }),
    }),
    getV2ProviderClaimsByClaimIdPdf: build.query<
      GetV2ProviderClaimsByClaimIdPdfApiResponse,
      GetV2ProviderClaimsByClaimIdPdfApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/claims/${queryArg.claimId}/pdf`,
      }),
    }),
    getV2ProviderClaimsByClaimIdReadiness: build.query<
      GetV2ProviderClaimsByClaimIdReadinessApiResponse,
      GetV2ProviderClaimsByClaimIdReadinessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/claims/${queryArg.claimId}/readiness`,
      }),
    }),
    postV2ProviderClaimsByClaimIdRebuild: build.mutation<
      PostV2ProviderClaimsByClaimIdRebuildApiResponse,
      PostV2ProviderClaimsByClaimIdRebuildApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/claims/${queryArg.claimId}/rebuild`,
        method: "POST",
        body: queryArg.rebuildClaimRequest,
      }),
    }),
    postV2ProviderClaimsByClaimIdResubmit: build.mutation<
      PostV2ProviderClaimsByClaimIdResubmitApiResponse,
      PostV2ProviderClaimsByClaimIdResubmitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/claims/${queryArg.claimId}/resubmit`,
        method: "POST",
        body: queryArg.createResubmissionClaimRequest,
      }),
    }),
    postV2ProviderClaimsByClaimIdScrub: build.mutation<
      PostV2ProviderClaimsByClaimIdScrubApiResponse,
      PostV2ProviderClaimsByClaimIdScrubApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/claims/${queryArg.claimId}/scrub`,
        method: "POST",
        body: queryArg.claimScrubRequest,
      }),
    }),
    getV2ProviderClaimsByClaimIdStediPdf: build.query<
      GetV2ProviderClaimsByClaimIdStediPdfApiResponse,
      GetV2ProviderClaimsByClaimIdStediPdfApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/claims/${queryArg.claimId}/stedi-pdf`,
        params: {
          background: queryArg.background,
        },
      }),
    }),
    postV2ProviderClaimsByClaimIdSubmit: build.mutation<
      PostV2ProviderClaimsByClaimIdSubmitApiResponse,
      PostV2ProviderClaimsByClaimIdSubmitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/claims/${queryArg.claimId}/submit`,
        method: "POST",
        body: queryArg.submitClaimRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderBillingClaimsApiResponse =
  /** status 200 OK */ OrgClaimListResponse;
export type GetV2ProviderBillingClaimsApiArg = {
  /** Filter by patient ID */
  patientId?: string | null;
  /** Comma-separated provider IDs to filter by */
  providerIds?: string | null;
  /** Filter by claim status (draft, processing, ready, submitted, acknowledged, accepted, rejected, paid, partially_paid, denied, reversed, imported) */
  status?: string | null;
  /** Filter by payer UUID */
  payerUuid?: string | null;
  /** Filter claims with service date from this date (ISO 8601) */
  dateFrom?: string | null;
  /** Filter claims with service date up to this date (ISO 8601) */
  dateTo?: string | null;
  /** Filter claims submitted from this date (ISO 8601) */
  submissionDateFrom?: string | null;
  /** Filter claims submitted up to this date (ISO 8601) */
  submissionDateTo?: string | null;
  /** Minimum total_charge_cents */
  chargeMin?: number | null;
  /** Maximum total_charge_cents */
  chargeMax?: number | null;
  /** Minimum balance_due_cents */
  balanceMin?: number | null;
  /** Maximum balance_due_cents */
  balanceMax?: number | null;
  /** Filter by source system (jotpsych, collabmd, etc.) */
  sourceSystem?: string | null;
  /** Filter by claim type (original, corrected, void) */
  claimType?: string | null;
  /** Smart queue filter (needs_attention, ready_to_submit, blocked, submitted, denied, paid, imported). Overrides status if both provided. */
  queue?: string | null;
  /** Include claims that have been superseded by a correction or void. Default hides superseded claims. */
  includeSuperseded?: boolean;
  /** Field to sort by (created_at, service_date_from, total_charge_cents) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2ProviderBillingClaimsQueueCountsApiResponse =
  /** status 200 OK */ ClaimQueueCounts;
export type GetV2ProviderBillingClaimsQueueCountsApiArg = {
  /** Filter by patient ID */
  patientId?: string | null;
  /** Comma-separated provider IDs to filter by */
  providerIds?: string | null;
  /** Filter by claim status (draft, processing, ready, submitted, acknowledged, accepted, rejected, paid, partially_paid, denied, reversed, imported) */
  status?: string | null;
  /** Filter by payer UUID */
  payerUuid?: string | null;
  /** Filter claims with service date from this date (ISO 8601) */
  dateFrom?: string | null;
  /** Filter claims with service date up to this date (ISO 8601) */
  dateTo?: string | null;
  /** Filter claims submitted from this date (ISO 8601) */
  submissionDateFrom?: string | null;
  /** Filter claims submitted up to this date (ISO 8601) */
  submissionDateTo?: string | null;
  /** Minimum total_charge_cents */
  chargeMin?: number | null;
  /** Maximum total_charge_cents */
  chargeMax?: number | null;
  /** Minimum balance_due_cents */
  balanceMin?: number | null;
  /** Maximum balance_due_cents */
  balanceMax?: number | null;
  /** Filter by source system (jotpsych, collabmd, etc.) */
  sourceSystem?: string | null;
  /** Filter by claim type (original, corrected, void) */
  claimType?: string | null;
  /** Smart queue filter (needs_attention, ready_to_submit, blocked, submitted, denied, paid, imported). Overrides status if both provided. */
  queue?: string | null;
  /** Include claims that have been superseded by a correction or void. Default hides superseded claims. */
  includeSuperseded?: boolean;
  /** Field to sort by (created_at, service_date_from, total_charge_cents) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2ProviderBillingClaimsByClaimIdApiResponse =
  /** status 200 OK */ OrgClaimDetailResponse;
export type GetV2ProviderBillingClaimsByClaimIdApiArg = {
  claimId: string;
};
export type GetV2ProviderClaimsApiResponse =
  /** status 200 OK */ ClaimListResponse;
export type GetV2ProviderClaimsApiArg = {
  /** Filter by patient ID */
  patientId?: string | null;
  /** Filter by claim status (draft, processing, scrubbing, ready, submitted, acknowledged, accepted, or rejected) */
  status?: string | null;
  /** Filter by payer UUID */
  payerUuid?: string | null;
  /** Filter claims with service date from this date (YYYY-MM-DD) */
  dateFrom?: string | null;
  /** Filter claims with service date up to this date (YYYY-MM-DD) */
  dateTo?: string | null;
  /** Field to sort by (created_at, service_date_from, claim_number, total_charge_cents) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
  /** Page number */
  page?: number;
  /** Number of items per page */
  pageSize?: number;
};
export type PostV2ProviderClaimsApiResponse =
  /** status 200 OK */ ClaimResponse2;
export type PostV2ProviderClaimsApiArg = {
  createClaimRequest: CreateClaimRequest;
};
export type PostV2ProviderClaimsBatchSubmitApiResponse =
  /** status 200 OK */ BatchSubmitClaimsResponse;
export type PostV2ProviderClaimsBatchSubmitApiArg = {
  batchSubmitClaimsRequest: BatchSubmitClaimsRequest;
};
export type DeleteV2ProviderClaimsByClaimIdApiResponse =
  /** status 200 OK */ ClaimDeleteResponse;
export type DeleteV2ProviderClaimsByClaimIdApiArg = {
  claimId: string;
};
export type GetV2ProviderClaimsByClaimIdApiResponse =
  /** status 200 OK */ ClaimResponse2;
export type GetV2ProviderClaimsByClaimIdApiArg = {
  claimId: string;
};
export type PutV2ProviderClaimsByClaimIdApiResponse =
  /** status 200 OK */ ClaimResponse2;
export type PutV2ProviderClaimsByClaimIdApiArg = {
  claimId: string;
  updateClaimRequest: UpdateClaimRequest;
};
export type PostV2ProviderClaimsByClaimIdAttentionApiResponse =
  /** status 200 OK */ ClaimAttentionResponse;
export type PostV2ProviderClaimsByClaimIdAttentionApiArg = {
  claimId: string;
  claimAttentionRequest: ClaimAttentionRequest;
};
export type GetV2ProviderClaimsByClaimIdPdfApiResponse =
  /** status 200 OK */ ClaimPdfGenerateResponse;
export type GetV2ProviderClaimsByClaimIdPdfApiArg = {
  claimId: string;
};
export type GetV2ProviderClaimsByClaimIdReadinessApiResponse =
  /** status 200 OK */ ClaimSubmissionReadinessResponse;
export type GetV2ProviderClaimsByClaimIdReadinessApiArg = {
  claimId: string;
};
export type PostV2ProviderClaimsByClaimIdRebuildApiResponse =
  /** status 200 OK */ ClaimResponse2;
export type PostV2ProviderClaimsByClaimIdRebuildApiArg = {
  claimId: string;
  rebuildClaimRequest: RebuildClaimRequest;
};
export type PostV2ProviderClaimsByClaimIdResubmitApiResponse =
  /** status 200 OK */ ClaimResponse2;
export type PostV2ProviderClaimsByClaimIdResubmitApiArg = {
  claimId: string;
  createResubmissionClaimRequest: CreateResubmissionClaimRequest;
};
export type PostV2ProviderClaimsByClaimIdScrubApiResponse =
  /** status 200 OK */ ClaimResponse2;
export type PostV2ProviderClaimsByClaimIdScrubApiArg = {
  claimId: string;
  claimScrubRequest: ClaimScrubRequest;
};
export type GetV2ProviderClaimsByClaimIdStediPdfApiResponse =
  /** status 200 OK */ ClaimPdfGenerateResponse;
export type GetV2ProviderClaimsByClaimIdStediPdfApiArg = {
  claimId: string;
  /** If true, PDF includes the CMS-1500 form overlay. If false, data only on white background (for printing on pre-printed forms). */
  background?: boolean;
};
export type PostV2ProviderClaimsByClaimIdSubmitApiResponse =
  /** status 200 OK */ SubmitClaimResponse;
export type PostV2ProviderClaimsByClaimIdSubmitApiArg = {
  claimId: string;
  submitClaimRequest: SubmitClaimRequest;
};
export type ClaimListItem = {
  /** Amount paid by payer in cents */
  amount_paid_cents?: number | null;
  /** Balance due in cents */
  balance_due_cents?: number | null;
  /** Claim ID */
  claim_id: string;
  /** Claim type: original, corrected, or void */
  claim_type?: string | null;
  /** Whether this claim can be corrected (post-submission + has PCN) */
  correction_eligible?: boolean;
  /** When claim was created */
  created_at: string;
  /** Days elapsed since submission */
  days_since_submission?: number | null;
  /** Encounter ID for linking to encounter detail */
  encounter_id?: string | null;
  /** Number of ERROR severity annotations */
  error_count?: number;
  /** Whether this claim has correction or void children */
  has_children?: boolean;
  /** Whether any ERA has been received for this claim */
  has_remittance?: boolean;
  /** Number of INFO severity annotations */
  info_count?: number;
  /** One-sentence next action for billing staff */
  next_action?: string | null;
  /** Priority level: urgent, action_needed, monitor, or none */
  next_action_priority?: string | null;
  /** Parent claim ID for corrections/voids */
  parent_claim_id?: string | null;
  /** Patient control number (PCN) */
  patient_control_number?: string | null;
  /** Patient ID */
  patient_id?: string | null;
  /** Patient display name (enriched) */
  patient_name?: string | null;
  /** Patient responsibility amount from ERA */
  patient_responsibility_cents?: number | null;
  /** Insurance payer name */
  payer_name?: string | null;
  /** Payer UUID */
  payer_uuid?: string | null;
  /** Top CARC code (e.g., CO-16) */
  primary_denial_code?: string | null;
  /** Human-readable denial reason */
  primary_denial_description?: string | null;
  /** Provider ID */
  provider_id?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** Blocked level: org, entity, or claim_data */
  readiness_blocked_level?: string | null;
  /** Human-readable blocker description */
  readiness_blocked_message?: string | null;
  /** Submission readiness: READY or BLOCKED */
  readiness_status?: string | null;
  /** Service date from */
  service_date_from?: string | null;
  /** Service date to */
  service_date_to?: string | null;
  /** Origin system */
  source_system?: string;
  /** Claim lifecycle status */
  status: string;
  /** When claim was submitted */
  submitted_at?: string | null;
  /** ID of the correction/void claim that supersedes this one */
  superseded_by_claim_id?: string | null;
  /** Message of the highest-severity annotation */
  top_blocker?: string | null;
  /** Total charge amount in cents */
  total_charge_cents?: number | null;
  /** When claim was last updated */
  updated_at: string;
  /** Number of WARNING severity annotations */
  warning_count?: number;
};
export type OrgClaimListResponse = {
  /** List of enriched claim items */
  claims: ClaimListItem[];
  /** Current page number */
  page: number;
  /** Items per page */
  per_page: number;
  /** Total number of claims */
  total: number;
  /** Total number of pages */
  total_pages: number;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type ClaimQueueCounts = {
  /** Draft claims with blockers */
  blocked?: number;
  /** Denied claims */
  denied?: number;
  /** Imported historical claims */
  imported?: number;
  /** Claims needing immediate action */
  needs_attention?: number;
  /** Paid or partially paid claims */
  paid?: number;
  /** Claims ready for submission */
  ready_to_submit?: number;
  /** Claims in-flight (submitted/acknowledged/accepted) */
  submitted?: number;
  /** Total claim count */
  total?: number;
};
export type ClaimDetailLineage = {
  /** IDs of correction/void claims derived from this claim */
  child_claim_ids?: string[];
  /** ID of the original claim this was corrected/voided from */
  parent_claim_id?: string | null;
};
export type OrgClaimDetailResponse = {
  /** Full claim data */
  claim: {
    [key: string]: any;
  };
  /** Parent and child claim relationships */
  lineage: ClaimDetailLineage;
};
export type AnnotationSeverity = "error" | "warning" | "info";
export type ClaimAnnotation = {
  /** CMS-1500 box number for the related field (e.g., '33A', '23') */
  cms_box?: string | null;
  /** Primary field that this annotation relates to */
  field?: string | null;
  /** The annotation message */
  message: string;
  /** ID of the rule that generated this annotation (if applicable) */
  rule_id?: string | null;
  /** Human-readable name of the rule (if applicable) */
  rule_name?: string | null;
  /** Severity level of the annotation */
  severity: AnnotationSeverity;
};
export type AttentionDisposition = {
  dismissed_at?: string | null;
  dismissed_by?: string | null;
  snoozed_until?: string | null;
};
export type BillingAddress = {
  /** Phone area code (3 digits) */
  area_code?: string | null;
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (optional) */
  line2?: string | null;
  /** Phone number (7 digits) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code */
  zip?: string | null;
};
export type ClaimLine = {
  /** Charge amount in cents (Box 24F) */
  charge_cents?: number | null;
  /** The claim this line belongs to. */
  claim_id?: string | null;
  /** CPT/HCPCS procedure code (Box 24D) */
  cpt_code?: string | null;
  /** Service date from (Box 24A) */
  date_from?: string | null;
  /** Service date to - optional for single date (Box 24A) */
  date_to?: string | null;
  /** Soft deletion timestamp */
  deleted_at?: string | null;
  /** Diagnosis pointers A-L (Box 24E) */
  diagnosis_pointers?: string[];
  /** Emergency indicator (Box 24C) */
  emg?: string | null;
  /** Encounter this line was billed from, if any. */
  encounter_id?: string | null;
  /** EPSDT Family Plan (Box 24H) */
  epsdt_family_plan?: string | null;
  /** Claim line ID (UUID). None until persisted. */
  id?: string | null;
  /** Line control number */
  line_control_number?: string | null;
  /** 1-based position of this line on the claim. */
  line_number?: number | null;
  /** CPT modifiers - max 4 (Box 24D) */
  modifiers?: string[];
  /** Place of service code override (Box 24B) */
  pos_code?: string | null;
  /** ID qualifiers (Box 24I) */
  qualifiers?: {
    [key: string]: any;
  } | null;
  /** Rendering provider NPI (Box 24J) */
  rendering_provider_npi?: string | null;
  /** Units of service (Box 24G) */
  units?: number | string;
};
export type ClaimType = "original" | "corrected" | "void";
export type AttentionLane =
  | "payer_rework"
  | "patient_billing"
  | "reversal"
  | "manual_review";
export type EraTriage = {
  attention_lane?: AttentionLane | null;
  needs_attention: boolean;
  signals?: string[];
  summary: string;
};
export type ClaimFrequencyCode = "1" | "7" | "8";
export type InsuranceType =
  | "Medicare"
  | "Medicaid"
  | "TRICARE"
  | "CHAMPVA"
  | "GroupHealthPlan"
  | "FECA"
  | "Other";
export type Sex = "Male" | "Female";
export type ClaimStatus =
  | "draft"
  | "processing"
  | "scrubbing"
  | "ready"
  | "submitted"
  | "acknowledged"
  | "accepted"
  | "rejected"
  | "paid"
  | "partially_paid"
  | "denied"
  | "reversed"
  | "imported";
export type TaxIdType = "EIN" | "SSN";
export type ClaimResponse = {
  /** Provider accepts assignment of benefits (Box 27) */
  accept_assignment?: boolean;
  /** Additional claim information (Designated by NUCC) (Box 19) */
  additional_claim_info?: string | null;
  /** Amount paid in cents (Box 29) */
  amount_paid_cents?: number;
  /** JSONB array of ClaimAnnotation objects from all sources (generation, validation, scrubbing) */
  annotations?: ClaimAnnotation[];
  /** User dismiss/snooze state */
  attention_disposition?: AttentionDisposition | null;
  /** Balance due in cents (Box 30) */
  balance_due_cents?: number;
  /** Member whose NPI renders this claim when a bill-under override applied */
  bill_under_user_id?: string | null;
  /** Provider billing address (Box 33) */
  billing_address?: BillingAddress | null;
  /** FK to billing_entities for submission identity */
  billing_entity_id?: string | null;
  /** Billing provider NPI number - 10 digits (Box 33A) */
  billing_provider_npi?: string | null;
  /** Line items on the claim (CMS-1500 Box 24). */
  claim_lines?: ClaimLine[];
  /** Claim semantic type: original, corrected, or void */
  claim_type?: ClaimType | null;
  created_at?: string | null;
  /** User ID who created the claim. */
  created_by?: string | null;
  created_by_principal_id?: string | null;
  created_by_principal_kind?:
    | ("user" | "staff" | "agent" | "system" | "patient")
    | null;
  /** Date of current illness, injury, or pregnancy (Box 14) */
  date_current_illness_injury?: string | null;
  /** Date of same or similar illness (Box 15) */
  date_similar_illness?: string | null;
  /** Dates patient unable to work - from (Box 16) */
  date_unable_to_work_from?: string | null;
  /** Dates patient unable to work - to (Box 16) */
  date_unable_to_work_to?: string | null;
  /** Soft-delete timestamp. None if the claim is active. */
  deleted_at?: string | null;
  /** ICD-10 diagnosis codes - max 12 (Box 21) */
  diagnoses?: string[];
  /** ERA triage decision blob */
  era_triage?: EraTriage | null;
  /** X12 frequency code for claim submission (1, 7, 8) */
  frequency_code?: ClaimFrequencyCode | null;
  /** Hospitalization dates related to current services - from (Box 18) */
  hospitalization_date_from?: string | null;
  /** Hospitalization dates related to current services - to (Box 18) */
  hospitalization_date_to?: string | null;
  /** Claim ID (UUID), the primary key. None until persisted. */
  id?: string | null;
  /** Import batch this claim came from, for claims migrated from an external system. */
  import_batch_id?: string | null;
  /** Insurance company name for forms/display */
  insurance_payer_name?: string | null;
  /** Type of insurance (Box 1) */
  insurance_type?: InsuranceType | null;
  /** Owning organization (tenant) ID. */
  organization_id?: string | null;
  /** Original reference number (Box 22) */
  original_reference_number?: string | null;
  /** Other insured first name (Box 9) */
  other_insured_first_name?: string | null;
  /** Other insured last name (Box 9) */
  other_insured_last_name?: string | null;
  /** Other insured middle initial (Box 9) */
  other_insured_middle_initial?: string | null;
  /** Other insured's insurance plan or program name (Box 9d) */
  other_insured_plan_name?: string | null;
  /** Other insured's policy or group number (Box 9a) */
  other_insured_policy_number?: string | null;
  /** Outside lab? (Box 20) */
  outside_lab?: boolean | null;
  /** Outside lab charges in cents (Box 20) */
  outside_lab_charges?: number | null;
  /** Parent claim ID for corrected/void claim lineage */
  parent_claim_id?: string | null;
  /** Patient account number (Box 26) */
  patient_account_number?: string | null;
  /** Patient mailing address (Box 5) */
  patient_address?: BillingAddress | null;
  /** Is condition related to auto accident? (Box 10b) */
  patient_condition_auto_accident?: boolean | null;
  /** State where auto accident occurred (Box 10b) */
  patient_condition_auto_accident_state?: string | null;
  /** Claim codes (Designated by NUCC) (Box 10d) */
  patient_condition_claim_codes?: string | null;
  /** Is condition related to patient's employment? (Box 10a) */
  patient_condition_employment_related?: boolean | null;
  /** Is condition related to other accident? (Box 10c) */
  patient_condition_other_accident?: boolean | null;
  /** Patient authorization signature on file (Box 12) */
  patient_consent_on_file?: boolean | null;
  /** Immutable claim-level control number used for clearinghouse correlation */
  patient_control_number?: string | null;
  /** Patient date of birth (Box 3) */
  patient_dob?: string | null;
  /** Patient first name (Box 2) */
  patient_first_name?: string | null;
  /** Patient the claim is for. Nullable for imported claims. */
  patient_id?: string | null;
  /** Patient last name (Box 2) */
  patient_last_name?: string | null;
  /** Patient middle initial (Box 2) */
  patient_middle_initial?: string | null;
  /** Patient sex (Box 3) */
  patient_sex?: Sex | null;
  /** Payer-assigned claim control number (e.g., 835 CLP07) */
  payer_claim_control_number?: string | null;
  /** FK to payers table for routing and enrollment checks */
  payer_uuid?: string | null;
  /** Place of service code (Box 24B) */
  place_of_service_code?: string | null;
  /** Primary insured address (Box 7) */
  primary_insured_address?: BillingAddress | null;
  /** Primary insured authorization signature on file (Box 13) */
  primary_insured_consent_on_file?: boolean | null;
  /** Primary insured date of birth (Box 11a) */
  primary_insured_dob?: string | null;
  /** Primary insured first name (Box 4) */
  primary_insured_first_name?: string | null;
  /** Primary insured's group number (Box 11) */
  primary_insured_group_number?: string | null;
  /** Is there another health benefit plan? (Box 11d) */
  primary_insured_has_other_plan?: boolean | null;
  /** Primary insured's ID number/policy number (Box 1a) */
  primary_insured_id_number?: string | null;
  /** Primary insured last name (Box 4) */
  primary_insured_last_name?: string | null;
  /** Primary insured middle initial (Box 4) */
  primary_insured_middle_initial?: string | null;
  /** Other claim ID (Designated by NUCC) (Box 11b) */
  primary_insured_other_claim_id?: string | null;
  /** Primary insured's insurance plan/program name (Box 11c) */
  primary_insured_plan_name?: string | null;
  /** Patient relationship to primary insured (Box 6) */
  primary_insured_relationship?: string | null;
  /** Primary insured sex (Box 11a) */
  primary_insured_sex?: Sex | null;
  /** Prior authorization number (Box 23) */
  prior_authorization_number?: string | null;
  /** Provider display name (Box 33) */
  provider_display_name?: string | null;
  /** Owning provider's user ID. Source of the protocol user_id. */
  provider_id?: string | null;
  /** Provider signature on file (Box 31) */
  provider_signature_on_file?: boolean | null;
  /** Name of referring provider or other source (Box 17) */
  referring_provider_name?: string | null;
  /** Referring provider NPI (Box 17b) */
  referring_provider_npi?: string | null;
  /** Rendering provider name for X12 2310B when it differs from Box 33 */
  rendering_provider_display_name?: string | null;
  /** Rendering provider taxonomy code (X12 2310B PRV03) */
  rendering_provider_taxonomy_code?: string | null;
  /** Resubmission code (Box 22) */
  resubmission_code?: string | null;
  /** Resource-protocol access scope; always "patient" for claims. */
  scope?: "global" | "organization" | "user" | "patient";
  /** Indicates if the claim has been scrubbed for validation. None/null means not scrubbed, False/True indicate scrubbed status. */
  scrubbed?: boolean | null;
  /** Service date from (Box 24A) */
  service_date_from?: string | null;
  /** Service date to (Box 24A) */
  service_date_to?: string | null;
  /** Service facility location info (Box 32) */
  service_facility?: {
    [key: string]: any;
  } | null;
  /** FK to service_facilities for traceability (ADR 0148) */
  service_facility_id?: string | null;
  /** Service facility NPI number (Box 32a) */
  service_facility_npi?: string | null;
  /** Origin system of the claim ('jotpsych' for native, else the imported billing system). */
  source_system?: string;
  /** Claim lifecycle status: draft → processing → ready → submitted → acknowledged/accepted/rejected → paid/partially_paid/denied/reversed (835 ERA outcomes). 'imported' marks read-only claims migrated from an external billing system. */
  status?: ClaimStatus;
  /** Stedi claim ID returned after submission */
  stedi_claim_id?: string | null;
  /** EDI control number for tracking */
  stedi_control_number?: string | null;
  /** When claim was submitted to Stedi */
  submitted_at?: string | null;
  /** ID of the correction/void claim that supersedes this one */
  superseded_by_claim_id?: string | null;
  /** Provider tax ID number (Box 25) */
  tax_id?: string | null;
  /** Tax ID type - EIN or SSN (Box 25) */
  tax_id_type?: TaxIdType | null;
  /** Total charges in cents (Box 28) */
  total_charge_cents?: number;
  updated_at?: string | null;
  /** Resource-protocol owner ID, derived from provider_id. Not persisted. */
  user_id?: string | null;
};
export type ClaimListResponse = {
  /** List of claims */
  claims: ClaimResponse[];
  /** Total number of claims */
  total: number;
};
export type AnnotationSeverity2 = "error" | "warning" | "info";
export type ClaimAnnotation2 = {
  /** CMS-1500 box number for the related field (e.g., '33A', '23') */
  cms_box?: string | null;
  /** Primary field that this annotation relates to */
  field?: string | null;
  /** The annotation message */
  message: string;
  /** ID of the rule that generated this annotation (if applicable) */
  rule_id?: string | null;
  /** Human-readable name of the rule (if applicable) */
  rule_name?: string | null;
  /** Severity level of the annotation */
  severity: AnnotationSeverity2;
};
export type AttentionDisposition2 = {
  dismissed_at?: string | null;
  dismissed_by?: string | null;
  snoozed_until?: string | null;
};
export type BillingAddress2 = {
  /** Phone area code (3 digits) */
  area_code?: string | null;
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (optional) */
  line2?: string | null;
  /** Phone number (7 digits) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code */
  zip?: string | null;
};
export type ClaimLine2 = {
  /** Charge amount in cents (Box 24F) */
  charge_cents?: number | null;
  /** The claim this line belongs to. */
  claim_id?: string | null;
  /** CPT/HCPCS procedure code (Box 24D) */
  cpt_code?: string | null;
  /** Service date from (Box 24A) */
  date_from?: string | null;
  /** Service date to - optional for single date (Box 24A) */
  date_to?: string | null;
  /** Soft deletion timestamp */
  deleted_at?: string | null;
  /** Diagnosis pointers A-L (Box 24E) */
  diagnosis_pointers?: string[];
  /** Emergency indicator (Box 24C) */
  emg?: string | null;
  /** Encounter this line was billed from, if any. */
  encounter_id?: string | null;
  /** EPSDT Family Plan (Box 24H) */
  epsdt_family_plan?: string | null;
  /** Claim line ID (UUID). None until persisted. */
  id?: string | null;
  /** Line control number */
  line_control_number?: string | null;
  /** 1-based position of this line on the claim. */
  line_number?: number | null;
  /** CPT modifiers - max 4 (Box 24D) */
  modifiers?: string[];
  /** Place of service code override (Box 24B) */
  pos_code?: string | null;
  /** ID qualifiers (Box 24I) */
  qualifiers?: {
    [key: string]: any;
  } | null;
  /** Rendering provider NPI (Box 24J) */
  rendering_provider_npi?: string | null;
  /** Units of service (Box 24G) */
  units?: number | string;
};
export type ClaimType2 = "original" | "corrected" | "void";
export type AttentionLane2 =
  | "payer_rework"
  | "patient_billing"
  | "reversal"
  | "manual_review";
export type EraTriage2 = {
  attention_lane?: AttentionLane2 | null;
  needs_attention: boolean;
  signals?: string[];
  summary: string;
};
export type ClaimFrequencyCode2 = "1" | "7" | "8";
export type InsuranceType2 =
  | "Medicare"
  | "Medicaid"
  | "TRICARE"
  | "CHAMPVA"
  | "GroupHealthPlan"
  | "FECA"
  | "Other";
export type Sex2 = "Male" | "Female";
export type ClaimStatus2 =
  | "draft"
  | "processing"
  | "scrubbing"
  | "ready"
  | "submitted"
  | "acknowledged"
  | "accepted"
  | "rejected"
  | "paid"
  | "partially_paid"
  | "denied"
  | "reversed"
  | "imported";
export type TaxIdType2 = "EIN" | "SSN";
export type ClaimResponse2 = {
  /** Provider accepts assignment of benefits (Box 27) */
  accept_assignment?: boolean;
  /** Additional claim information (Designated by NUCC) (Box 19) */
  additional_claim_info?: string | null;
  /** Amount paid in cents (Box 29) */
  amount_paid_cents?: number;
  /** JSONB array of ClaimAnnotation objects from all sources (generation, validation, scrubbing) */
  annotations?: ClaimAnnotation2[];
  /** User dismiss/snooze state */
  attention_disposition?: AttentionDisposition2 | null;
  /** Balance due in cents (Box 30) */
  balance_due_cents?: number;
  /** Member whose NPI renders this claim when a bill-under override applied */
  bill_under_user_id?: string | null;
  /** Provider billing address (Box 33) */
  billing_address?: BillingAddress2 | null;
  /** FK to billing_entities for submission identity */
  billing_entity_id?: string | null;
  /** Billing provider NPI number - 10 digits (Box 33A) */
  billing_provider_npi?: string | null;
  /** Line items on the claim (CMS-1500 Box 24). */
  claim_lines?: ClaimLine2[];
  /** Claim semantic type: original, corrected, or void */
  claim_type?: ClaimType2 | null;
  created_at?: string | null;
  /** User ID who created the claim. */
  created_by?: string | null;
  created_by_principal_id?: string | null;
  created_by_principal_kind?:
    | ("user" | "staff" | "agent" | "system" | "patient")
    | null;
  /** Date of current illness, injury, or pregnancy (Box 14) */
  date_current_illness_injury?: string | null;
  /** Date of same or similar illness (Box 15) */
  date_similar_illness?: string | null;
  /** Dates patient unable to work - from (Box 16) */
  date_unable_to_work_from?: string | null;
  /** Dates patient unable to work - to (Box 16) */
  date_unable_to_work_to?: string | null;
  /** Soft-delete timestamp. None if the claim is active. */
  deleted_at?: string | null;
  /** ICD-10 diagnosis codes - max 12 (Box 21) */
  diagnoses?: string[];
  /** ERA triage decision blob */
  era_triage?: EraTriage2 | null;
  /** X12 frequency code for claim submission (1, 7, 8) */
  frequency_code?: ClaimFrequencyCode2 | null;
  /** Hospitalization dates related to current services - from (Box 18) */
  hospitalization_date_from?: string | null;
  /** Hospitalization dates related to current services - to (Box 18) */
  hospitalization_date_to?: string | null;
  /** Claim ID (UUID), the primary key. None until persisted. */
  id?: string | null;
  /** Import batch this claim came from, for claims migrated from an external system. */
  import_batch_id?: string | null;
  /** Insurance company name for forms/display */
  insurance_payer_name?: string | null;
  /** Type of insurance (Box 1) */
  insurance_type?: InsuranceType2 | null;
  /** Owning organization (tenant) ID. */
  organization_id?: string | null;
  /** Original reference number (Box 22) */
  original_reference_number?: string | null;
  /** Other insured first name (Box 9) */
  other_insured_first_name?: string | null;
  /** Other insured last name (Box 9) */
  other_insured_last_name?: string | null;
  /** Other insured middle initial (Box 9) */
  other_insured_middle_initial?: string | null;
  /** Other insured's insurance plan or program name (Box 9d) */
  other_insured_plan_name?: string | null;
  /** Other insured's policy or group number (Box 9a) */
  other_insured_policy_number?: string | null;
  /** Outside lab? (Box 20) */
  outside_lab?: boolean | null;
  /** Outside lab charges in cents (Box 20) */
  outside_lab_charges?: number | null;
  /** Parent claim ID for corrected/void claim lineage */
  parent_claim_id?: string | null;
  /** Patient account number (Box 26) */
  patient_account_number?: string | null;
  /** Patient mailing address (Box 5) */
  patient_address?: BillingAddress2 | null;
  /** Is condition related to auto accident? (Box 10b) */
  patient_condition_auto_accident?: boolean | null;
  /** State where auto accident occurred (Box 10b) */
  patient_condition_auto_accident_state?: string | null;
  /** Claim codes (Designated by NUCC) (Box 10d) */
  patient_condition_claim_codes?: string | null;
  /** Is condition related to patient's employment? (Box 10a) */
  patient_condition_employment_related?: boolean | null;
  /** Is condition related to other accident? (Box 10c) */
  patient_condition_other_accident?: boolean | null;
  /** Patient authorization signature on file (Box 12) */
  patient_consent_on_file?: boolean | null;
  /** Immutable claim-level control number used for clearinghouse correlation */
  patient_control_number?: string | null;
  /** Patient date of birth (Box 3) */
  patient_dob?: string | null;
  /** Patient first name (Box 2) */
  patient_first_name?: string | null;
  /** Patient the claim is for. Nullable for imported claims. */
  patient_id?: string | null;
  /** Patient last name (Box 2) */
  patient_last_name?: string | null;
  /** Patient middle initial (Box 2) */
  patient_middle_initial?: string | null;
  /** Patient sex (Box 3) */
  patient_sex?: Sex2 | null;
  /** Payer-assigned claim control number (e.g., 835 CLP07) */
  payer_claim_control_number?: string | null;
  /** FK to payers table for routing and enrollment checks */
  payer_uuid?: string | null;
  /** Place of service code (Box 24B) */
  place_of_service_code?: string | null;
  /** Primary insured address (Box 7) */
  primary_insured_address?: BillingAddress2 | null;
  /** Primary insured authorization signature on file (Box 13) */
  primary_insured_consent_on_file?: boolean | null;
  /** Primary insured date of birth (Box 11a) */
  primary_insured_dob?: string | null;
  /** Primary insured first name (Box 4) */
  primary_insured_first_name?: string | null;
  /** Primary insured's group number (Box 11) */
  primary_insured_group_number?: string | null;
  /** Is there another health benefit plan? (Box 11d) */
  primary_insured_has_other_plan?: boolean | null;
  /** Primary insured's ID number/policy number (Box 1a) */
  primary_insured_id_number?: string | null;
  /** Primary insured last name (Box 4) */
  primary_insured_last_name?: string | null;
  /** Primary insured middle initial (Box 4) */
  primary_insured_middle_initial?: string | null;
  /** Other claim ID (Designated by NUCC) (Box 11b) */
  primary_insured_other_claim_id?: string | null;
  /** Primary insured's insurance plan/program name (Box 11c) */
  primary_insured_plan_name?: string | null;
  /** Patient relationship to primary insured (Box 6) */
  primary_insured_relationship?: string | null;
  /** Primary insured sex (Box 11a) */
  primary_insured_sex?: Sex2 | null;
  /** Prior authorization number (Box 23) */
  prior_authorization_number?: string | null;
  /** Provider display name (Box 33) */
  provider_display_name?: string | null;
  /** Owning provider's user ID. Source of the protocol user_id. */
  provider_id?: string | null;
  /** Provider signature on file (Box 31) */
  provider_signature_on_file?: boolean | null;
  /** Name of referring provider or other source (Box 17) */
  referring_provider_name?: string | null;
  /** Referring provider NPI (Box 17b) */
  referring_provider_npi?: string | null;
  /** Rendering provider name for X12 2310B when it differs from Box 33 */
  rendering_provider_display_name?: string | null;
  /** Rendering provider taxonomy code (X12 2310B PRV03) */
  rendering_provider_taxonomy_code?: string | null;
  /** Resubmission code (Box 22) */
  resubmission_code?: string | null;
  /** Resource-protocol access scope; always "patient" for claims. */
  scope?: "global" | "organization" | "user" | "patient";
  /** Indicates if the claim has been scrubbed for validation. None/null means not scrubbed, False/True indicate scrubbed status. */
  scrubbed?: boolean | null;
  /** Service date from (Box 24A) */
  service_date_from?: string | null;
  /** Service date to (Box 24A) */
  service_date_to?: string | null;
  /** Service facility location info (Box 32) */
  service_facility?: {
    [key: string]: any;
  } | null;
  /** FK to service_facilities for traceability (ADR 0148) */
  service_facility_id?: string | null;
  /** Service facility NPI number (Box 32a) */
  service_facility_npi?: string | null;
  /** Origin system of the claim ('jotpsych' for native, else the imported billing system). */
  source_system?: string;
  /** Claim lifecycle status: draft → processing → ready → submitted → acknowledged/accepted/rejected → paid/partially_paid/denied/reversed (835 ERA outcomes). 'imported' marks read-only claims migrated from an external billing system. */
  status?: ClaimStatus2;
  /** Stedi claim ID returned after submission */
  stedi_claim_id?: string | null;
  /** EDI control number for tracking */
  stedi_control_number?: string | null;
  /** When claim was submitted to Stedi */
  submitted_at?: string | null;
  /** ID of the correction/void claim that supersedes this one */
  superseded_by_claim_id?: string | null;
  /** Provider tax ID number (Box 25) */
  tax_id?: string | null;
  /** Tax ID type - EIN or SSN (Box 25) */
  tax_id_type?: TaxIdType2 | null;
  /** Total charges in cents (Box 28) */
  total_charge_cents?: number;
  updated_at?: string | null;
  /** Resource-protocol owner ID, derived from provider_id. Not persisted. */
  user_id?: string | null;
};
export type CreateClaimRequest = {
  /** List of encounter IDs to include in the claim */
  encounter_ids: string[];
  /** Patient ID for the claim */
  patient_id: string;
  /** Rejected source claim replaced by this new original claim, when the create action is being used to correct a rejected claim. */
  supersedes_claim_id?: string | null;
  /** Why the new original claim supersedes the source claim. */
  supersession_reason?: "correct_rejected_original" | null;
};
export type BatchSubmitClaimFailure = {
  /** ID of the claim that failed */
  claim_id: string;
  /** Error message describing the failure */
  error: string;
};
export type BatchSubmitClaimsResponse = {
  /** Claims that failed submission with error details */
  failed: BatchSubmitClaimFailure[];
  /** Claim IDs that were successfully submitted */
  submitted: string[];
};
export type BatchSubmitClaimsRequest = {
  /** List of claim IDs to submit (must be in ready status) */
  claim_ids: string[];
};
export type ClaimDeleteResponse = {
  /** Deleted claim ID */
  claim_id: string;
  /** Deletion success flag */
  deleted: boolean;
  /** Deletion status message */
  message: string;
};
export type BillingAddress3 = {
  /** Phone area code (3 digits) */
  area_code?: string | null;
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (optional) */
  line2?: string | null;
  /** Phone number (7 digits) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code */
  zip?: string | null;
};
export type ClaimLine3 = {
  /** Charge amount in cents (Box 24F) */
  charge_cents?: number | null;
  /** The claim this line belongs to. */
  claim_id?: string | null;
  /** CPT/HCPCS procedure code (Box 24D) */
  cpt_code?: string | null;
  /** Service date from (Box 24A) */
  date_from?: string | null;
  /** Service date to - optional for single date (Box 24A) */
  date_to?: string | null;
  /** Soft deletion timestamp */
  deleted_at?: string | null;
  /** Diagnosis pointers A-L (Box 24E) */
  diagnosis_pointers?: string[];
  /** Emergency indicator (Box 24C) */
  emg?: string | null;
  /** Encounter this line was billed from, if any. */
  encounter_id?: string | null;
  /** EPSDT Family Plan (Box 24H) */
  epsdt_family_plan?: string | null;
  /** Claim line ID (UUID). None until persisted. */
  id?: string | null;
  /** Line control number */
  line_control_number?: string | null;
  /** 1-based position of this line on the claim. */
  line_number?: number | null;
  /** CPT modifiers - max 4 (Box 24D) */
  modifiers?: string[];
  /** Place of service code override (Box 24B) */
  pos_code?: string | null;
  /** ID qualifiers (Box 24I) */
  qualifiers?: {
    [key: string]: any;
  } | null;
  /** Rendering provider NPI (Box 24J) */
  rendering_provider_npi?: string | null;
  /** Units of service (Box 24G) */
  units?: number | string;
};
export type InsuranceType3 =
  | "Medicare"
  | "Medicaid"
  | "TRICARE"
  | "CHAMPVA"
  | "GroupHealthPlan"
  | "FECA"
  | "Other";
export type Sex3 = "Male" | "Female";
export type ClaimStatus3 =
  | "draft"
  | "processing"
  | "scrubbing"
  | "ready"
  | "submitted"
  | "acknowledged"
  | "accepted"
  | "rejected"
  | "paid"
  | "partially_paid"
  | "denied"
  | "reversed"
  | "imported";
export type TaxIdType3 = "EIN" | "SSN";
export type UpdateClaimRequest = {
  /** Whether provider accepts assignment */
  accept_assignment?: boolean | null;
  /** Additional claim information (Designated by NUCC) (Box 19) */
  additional_claim_info?: string | null;
  /** Amount paid in cents */
  amount_paid_cents?: number | null;
  /** Balance due in cents */
  balance_due_cents?: number | null;
  /** Billing address */
  billing_address?: BillingAddress3 | null;
  /** Billing provider NPI (Box 33A, 10 digits) */
  billing_provider_npi?: string | null;
  /** Claim line items */
  claim_lines?: ClaimLine3[] | null;
  /** Date of current illness, injury, or pregnancy (Box 14) - YYYY-MM-DD format */
  date_current_illness_injury?: string | null;
  /** Date of same or similar illness (Box 15) - YYYY-MM-DD format */
  date_similar_illness?: string | null;
  /** Dates patient unable to work - from (Box 16) - YYYY-MM-DD format */
  date_unable_to_work_from?: string | null;
  /** Dates patient unable to work - to (Box 16) - YYYY-MM-DD format */
  date_unable_to_work_to?: string | null;
  /** ICD-10 diagnosis codes (max 12) */
  diagnoses?: string[] | null;
  /** Additional CMS-1500 box data */
  extra_boxes?: {
    [key: string]: any;
  } | null;
  /** Hospitalization dates related to current services - from (Box 18) - YYYY-MM-DD format */
  hospitalization_date_from?: string | null;
  /** Hospitalization dates related to current services - to (Box 18) - YYYY-MM-DD format */
  hospitalization_date_to?: string | null;
  /** Insurance company name for forms/display */
  insurance_payer_name?: string | null;
  /** Type of insurance (Box 1) - Medicare, Medicaid, TRICARE, CHAMPVA, GroupHealthPlan, FECA, Other */
  insurance_type?: InsuranceType3 | null;
  /** Original reference number (Box 22) */
  original_reference_number?: string | null;
  /** Other insured first name (Box 9) */
  other_insured_first_name?: string | null;
  /** Other insured last name (Box 9) */
  other_insured_last_name?: string | null;
  /** Other insured middle initial (Box 9) */
  other_insured_middle_initial?: string | null;
  /** Other insured's insurance plan or program name (Box 9d) */
  other_insured_plan_name?: string | null;
  /** Other insured's policy or group number (Box 9a) */
  other_insured_policy_number?: string | null;
  /** Outside lab? (Box 20) */
  outside_lab?: boolean | null;
  /** Outside lab charges in cents (Box 20) */
  outside_lab_charges?: number | null;
  /** Patient account number */
  patient_account_number?: string | null;
  /** Patient mailing address (Box 5) - {line1, line2, city, state, zip} */
  patient_address?: {
    [key: string]: any;
  } | null;
  /** Is condition related to auto accident? (Box 10b) */
  patient_condition_auto_accident?: boolean | null;
  /** State where auto accident occurred (Box 10b) */
  patient_condition_auto_accident_state?: string | null;
  /** Claim codes (Designated by NUCC) (Box 10d) */
  patient_condition_claim_codes?: string | null;
  /** Is condition related to patient's employment? (Box 10a) */
  patient_condition_employment_related?: boolean | null;
  /** Is condition related to other accident? (Box 10c) */
  patient_condition_other_accident?: boolean | null;
  /** Patient authorization signature on file (Box 12) */
  patient_consent_on_file?: boolean | null;
  /** Patient date of birth (Box 3) - YYYY-MM-DD format */
  patient_dob?: string | null;
  /** Patient first name (Box 2) */
  patient_first_name?: string | null;
  /** Patient last name (Box 2) */
  patient_last_name?: string | null;
  /** Patient middle initial (Box 2) */
  patient_middle_initial?: string | null;
  /** Patient sex (Box 3) - Male or Female */
  patient_sex?: string | null;
  /** Place of service code */
  place_of_service_code?: string | null;
  /** Primary insured address (Box 7) */
  primary_insured_address?: BillingAddress3 | null;
  /** Primary insured authorization signature on file (Box 13) */
  primary_insured_consent_on_file?: boolean | null;
  /** Primary insured date of birth (Box 11a) - YYYY-MM-DD format */
  primary_insured_dob?: string | null;
  /** Primary insured first name (Box 4) */
  primary_insured_first_name?: string | null;
  /** Primary insured's group number (Box 11) */
  primary_insured_group_number?: string | null;
  /** Is there another health benefit plan? (Box 11d) */
  primary_insured_has_other_plan?: boolean | null;
  /** Primary insured's ID number/policy number (Box 1a) */
  primary_insured_id_number?: string | null;
  /** Primary insured last name (Box 4) */
  primary_insured_last_name?: string | null;
  /** Primary insured middle initial (Box 4) */
  primary_insured_middle_initial?: string | null;
  /** Other claim ID (Designated by NUCC) (Box 11b) */
  primary_insured_other_claim_id?: string | null;
  /** Primary insured's insurance plan/program name (Box 11c) */
  primary_insured_plan_name?: string | null;
  /** Patient relationship to primary insured (Box 6) */
  primary_insured_relationship?: string | null;
  /** Primary insured sex (Box 11a) - Male or Female */
  primary_insured_sex?: Sex3 | null;
  /** Prior authorization number (Box 23) */
  prior_authorization_number?: string | null;
  /** Provider display name */
  provider_display_name?: string | null;
  /** Provider signature on file (Box 31) */
  provider_signature_on_file?: boolean | null;
  /** Name of referring provider or other source (Box 17) */
  referring_provider_name?: string | null;
  /** Referring provider NPI (Box 17b) */
  referring_provider_npi?: string | null;
  /** Resubmission code (Box 22) */
  resubmission_code?: string | null;
  /** Service start date */
  service_date_from?: string | null;
  /** Service end date */
  service_date_to?: string | null;
  /** Service facility information */
  service_facility?: {
    [key: string]: any;
  } | null;
  /** Service facility NPI number (Box 32a) */
  service_facility_npi?: string | null;
  /** Claim status */
  status?: ClaimStatus3 | null;
  /** Tax ID number */
  tax_id?: string | null;
  /** Tax ID type (EIN or SSN) */
  tax_id_type?: TaxIdType3 | null;
  /** Total charges in cents */
  total_charge_cents?: number | null;
};
export type ClaimAttentionResponse = {
  action: string;
  claim_id: string;
};
export type ClaimAttentionRequest = {
  /** Action to take: dismiss or snooze */
  action: "dismiss" | "snooze";
  /** Required when action is 'snooze'. ISO-8601 datetime. */
  snooze_until?: string | null;
};
export type ClaimPdfGenerateResponse = {
  /** Suggested filename for the PDF */
  filename: string;
  /** Base64 encoded PDF data */
  pdf_data: string;
};
export type SubmissionBlockerResponse = {
  /** Recommended action to resolve */
  action: string;
  /** Machine-readable blocker code */
  code: string;
  /** Additional context */
  details?: {
    [key: string]: any;
  } | null;
  /** Readiness level (1=org, 2=entity, 3=payer, 4=claim) */
  level: number;
  /** Human-readable description */
  message: string;
};
export type ClaimSubmissionReadinessResponse = {
  blockers: SubmissionBlockerResponse[];
  can_generate: boolean;
  can_submit: boolean;
  claim_id: string;
  enrollment_status: string | null;
  evaluated_at: string;
  payer_status: string | null;
  status: string;
};
export type RebuildClaimRequest = {
  /** Optional encounter IDs to use. If omitted, recovers from existing claim lines. */
  encounter_ids?: string[] | null;
};
export type CreateResubmissionClaimRequest = {
  /** Original payer/clearinghouse claim reference number (Box 22) */
  original_reference_number?: string | null;
  /** 7=replacement claim, 8=void claim */
  resubmission_code: "7" | "8";
};
export type ClaimScrubRequest = {};
export type AnnotationSeverity3 = "error" | "warning" | "info";
export type ClaimAnnotation3 = {
  /** CMS-1500 box number for the related field (e.g., '33A', '23') */
  cms_box?: string | null;
  /** Primary field that this annotation relates to */
  field?: string | null;
  /** The annotation message */
  message: string;
  /** ID of the rule that generated this annotation (if applicable) */
  rule_id?: string | null;
  /** Human-readable name of the rule (if applicable) */
  rule_name?: string | null;
  /** Severity level of the annotation */
  severity: AnnotationSeverity3;
};
export type AttentionDisposition3 = {
  dismissed_at?: string | null;
  dismissed_by?: string | null;
  snoozed_until?: string | null;
};
export type BillingAddress4 = {
  /** Phone area code (3 digits) */
  area_code?: string | null;
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (optional) */
  line2?: string | null;
  /** Phone number (7 digits) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code */
  zip?: string | null;
};
export type ClaimLine4 = {
  /** Charge amount in cents (Box 24F) */
  charge_cents?: number | null;
  /** The claim this line belongs to. */
  claim_id?: string | null;
  /** CPT/HCPCS procedure code (Box 24D) */
  cpt_code?: string | null;
  /** Service date from (Box 24A) */
  date_from?: string | null;
  /** Service date to - optional for single date (Box 24A) */
  date_to?: string | null;
  /** Soft deletion timestamp */
  deleted_at?: string | null;
  /** Diagnosis pointers A-L (Box 24E) */
  diagnosis_pointers?: string[];
  /** Emergency indicator (Box 24C) */
  emg?: string | null;
  /** Encounter this line was billed from, if any. */
  encounter_id?: string | null;
  /** EPSDT Family Plan (Box 24H) */
  epsdt_family_plan?: string | null;
  /** Claim line ID (UUID). None until persisted. */
  id?: string | null;
  /** Line control number */
  line_control_number?: string | null;
  /** 1-based position of this line on the claim. */
  line_number?: number | null;
  /** CPT modifiers - max 4 (Box 24D) */
  modifiers?: string[];
  /** Place of service code override (Box 24B) */
  pos_code?: string | null;
  /** ID qualifiers (Box 24I) */
  qualifiers?: {
    [key: string]: any;
  } | null;
  /** Rendering provider NPI (Box 24J) */
  rendering_provider_npi?: string | null;
  /** Units of service (Box 24G) */
  units?: number | string;
};
export type ClaimType3 = "original" | "corrected" | "void";
export type AttentionLane3 =
  | "payer_rework"
  | "patient_billing"
  | "reversal"
  | "manual_review";
export type EraTriage3 = {
  attention_lane?: AttentionLane3 | null;
  needs_attention: boolean;
  signals?: string[];
  summary: string;
};
export type ClaimFrequencyCode3 = "1" | "7" | "8";
export type InsuranceType4 =
  | "Medicare"
  | "Medicaid"
  | "TRICARE"
  | "CHAMPVA"
  | "GroupHealthPlan"
  | "FECA"
  | "Other";
export type Sex4 = "Male" | "Female";
export type ClaimStatus4 =
  | "draft"
  | "processing"
  | "scrubbing"
  | "ready"
  | "submitted"
  | "acknowledged"
  | "accepted"
  | "rejected"
  | "paid"
  | "partially_paid"
  | "denied"
  | "reversed"
  | "imported";
export type TaxIdType4 = "EIN" | "SSN";
export type ClaimResponse3 = {
  /** Provider accepts assignment of benefits (Box 27) */
  accept_assignment?: boolean;
  /** Additional claim information (Designated by NUCC) (Box 19) */
  additional_claim_info?: string | null;
  /** Amount paid in cents (Box 29) */
  amount_paid_cents?: number;
  /** JSONB array of ClaimAnnotation objects from all sources (generation, validation, scrubbing) */
  annotations?: ClaimAnnotation3[];
  /** User dismiss/snooze state */
  attention_disposition?: AttentionDisposition3 | null;
  /** Balance due in cents (Box 30) */
  balance_due_cents?: number;
  /** Member whose NPI renders this claim when a bill-under override applied */
  bill_under_user_id?: string | null;
  /** Provider billing address (Box 33) */
  billing_address?: BillingAddress4 | null;
  /** FK to billing_entities for submission identity */
  billing_entity_id?: string | null;
  /** Billing provider NPI number - 10 digits (Box 33A) */
  billing_provider_npi?: string | null;
  /** Line items on the claim (CMS-1500 Box 24). */
  claim_lines?: ClaimLine4[];
  /** Claim semantic type: original, corrected, or void */
  claim_type?: ClaimType3 | null;
  created_at?: string | null;
  /** User ID who created the claim. */
  created_by?: string | null;
  created_by_principal_id?: string | null;
  created_by_principal_kind?:
    | ("user" | "staff" | "agent" | "system" | "patient")
    | null;
  /** Date of current illness, injury, or pregnancy (Box 14) */
  date_current_illness_injury?: string | null;
  /** Date of same or similar illness (Box 15) */
  date_similar_illness?: string | null;
  /** Dates patient unable to work - from (Box 16) */
  date_unable_to_work_from?: string | null;
  /** Dates patient unable to work - to (Box 16) */
  date_unable_to_work_to?: string | null;
  /** Soft-delete timestamp. None if the claim is active. */
  deleted_at?: string | null;
  /** ICD-10 diagnosis codes - max 12 (Box 21) */
  diagnoses?: string[];
  /** ERA triage decision blob */
  era_triage?: EraTriage3 | null;
  /** X12 frequency code for claim submission (1, 7, 8) */
  frequency_code?: ClaimFrequencyCode3 | null;
  /** Hospitalization dates related to current services - from (Box 18) */
  hospitalization_date_from?: string | null;
  /** Hospitalization dates related to current services - to (Box 18) */
  hospitalization_date_to?: string | null;
  /** Claim ID (UUID), the primary key. None until persisted. */
  id?: string | null;
  /** Import batch this claim came from, for claims migrated from an external system. */
  import_batch_id?: string | null;
  /** Insurance company name for forms/display */
  insurance_payer_name?: string | null;
  /** Type of insurance (Box 1) */
  insurance_type?: InsuranceType4 | null;
  /** Owning organization (tenant) ID. */
  organization_id?: string | null;
  /** Original reference number (Box 22) */
  original_reference_number?: string | null;
  /** Other insured first name (Box 9) */
  other_insured_first_name?: string | null;
  /** Other insured last name (Box 9) */
  other_insured_last_name?: string | null;
  /** Other insured middle initial (Box 9) */
  other_insured_middle_initial?: string | null;
  /** Other insured's insurance plan or program name (Box 9d) */
  other_insured_plan_name?: string | null;
  /** Other insured's policy or group number (Box 9a) */
  other_insured_policy_number?: string | null;
  /** Outside lab? (Box 20) */
  outside_lab?: boolean | null;
  /** Outside lab charges in cents (Box 20) */
  outside_lab_charges?: number | null;
  /** Parent claim ID for corrected/void claim lineage */
  parent_claim_id?: string | null;
  /** Patient account number (Box 26) */
  patient_account_number?: string | null;
  /** Patient mailing address (Box 5) */
  patient_address?: BillingAddress4 | null;
  /** Is condition related to auto accident? (Box 10b) */
  patient_condition_auto_accident?: boolean | null;
  /** State where auto accident occurred (Box 10b) */
  patient_condition_auto_accident_state?: string | null;
  /** Claim codes (Designated by NUCC) (Box 10d) */
  patient_condition_claim_codes?: string | null;
  /** Is condition related to patient's employment? (Box 10a) */
  patient_condition_employment_related?: boolean | null;
  /** Is condition related to other accident? (Box 10c) */
  patient_condition_other_accident?: boolean | null;
  /** Patient authorization signature on file (Box 12) */
  patient_consent_on_file?: boolean | null;
  /** Immutable claim-level control number used for clearinghouse correlation */
  patient_control_number?: string | null;
  /** Patient date of birth (Box 3) */
  patient_dob?: string | null;
  /** Patient first name (Box 2) */
  patient_first_name?: string | null;
  /** Patient the claim is for. Nullable for imported claims. */
  patient_id?: string | null;
  /** Patient last name (Box 2) */
  patient_last_name?: string | null;
  /** Patient middle initial (Box 2) */
  patient_middle_initial?: string | null;
  /** Patient sex (Box 3) */
  patient_sex?: Sex4 | null;
  /** Payer-assigned claim control number (e.g., 835 CLP07) */
  payer_claim_control_number?: string | null;
  /** FK to payers table for routing and enrollment checks */
  payer_uuid?: string | null;
  /** Place of service code (Box 24B) */
  place_of_service_code?: string | null;
  /** Primary insured address (Box 7) */
  primary_insured_address?: BillingAddress4 | null;
  /** Primary insured authorization signature on file (Box 13) */
  primary_insured_consent_on_file?: boolean | null;
  /** Primary insured date of birth (Box 11a) */
  primary_insured_dob?: string | null;
  /** Primary insured first name (Box 4) */
  primary_insured_first_name?: string | null;
  /** Primary insured's group number (Box 11) */
  primary_insured_group_number?: string | null;
  /** Is there another health benefit plan? (Box 11d) */
  primary_insured_has_other_plan?: boolean | null;
  /** Primary insured's ID number/policy number (Box 1a) */
  primary_insured_id_number?: string | null;
  /** Primary insured last name (Box 4) */
  primary_insured_last_name?: string | null;
  /** Primary insured middle initial (Box 4) */
  primary_insured_middle_initial?: string | null;
  /** Other claim ID (Designated by NUCC) (Box 11b) */
  primary_insured_other_claim_id?: string | null;
  /** Primary insured's insurance plan/program name (Box 11c) */
  primary_insured_plan_name?: string | null;
  /** Patient relationship to primary insured (Box 6) */
  primary_insured_relationship?: string | null;
  /** Primary insured sex (Box 11a) */
  primary_insured_sex?: Sex4 | null;
  /** Prior authorization number (Box 23) */
  prior_authorization_number?: string | null;
  /** Provider display name (Box 33) */
  provider_display_name?: string | null;
  /** Owning provider's user ID. Source of the protocol user_id. */
  provider_id?: string | null;
  /** Provider signature on file (Box 31) */
  provider_signature_on_file?: boolean | null;
  /** Name of referring provider or other source (Box 17) */
  referring_provider_name?: string | null;
  /** Referring provider NPI (Box 17b) */
  referring_provider_npi?: string | null;
  /** Rendering provider name for X12 2310B when it differs from Box 33 */
  rendering_provider_display_name?: string | null;
  /** Rendering provider taxonomy code (X12 2310B PRV03) */
  rendering_provider_taxonomy_code?: string | null;
  /** Resubmission code (Box 22) */
  resubmission_code?: string | null;
  /** Resource-protocol access scope; always "patient" for claims. */
  scope?: "global" | "organization" | "user" | "patient";
  /** Indicates if the claim has been scrubbed for validation. None/null means not scrubbed, False/True indicate scrubbed status. */
  scrubbed?: boolean | null;
  /** Service date from (Box 24A) */
  service_date_from?: string | null;
  /** Service date to (Box 24A) */
  service_date_to?: string | null;
  /** Service facility location info (Box 32) */
  service_facility?: {
    [key: string]: any;
  } | null;
  /** FK to service_facilities for traceability (ADR 0148) */
  service_facility_id?: string | null;
  /** Service facility NPI number (Box 32a) */
  service_facility_npi?: string | null;
  /** Origin system of the claim ('jotpsych' for native, else the imported billing system). */
  source_system?: string;
  /** Claim lifecycle status: draft → processing → ready → submitted → acknowledged/accepted/rejected → paid/partially_paid/denied/reversed (835 ERA outcomes). 'imported' marks read-only claims migrated from an external billing system. */
  status?: ClaimStatus4;
  /** Stedi claim ID returned after submission */
  stedi_claim_id?: string | null;
  /** EDI control number for tracking */
  stedi_control_number?: string | null;
  /** When claim was submitted to Stedi */
  submitted_at?: string | null;
  /** ID of the correction/void claim that supersedes this one */
  superseded_by_claim_id?: string | null;
  /** Provider tax ID number (Box 25) */
  tax_id?: string | null;
  /** Tax ID type - EIN or SSN (Box 25) */
  tax_id_type?: TaxIdType4 | null;
  /** Total charges in cents (Box 28) */
  total_charge_cents?: number;
  updated_at?: string | null;
  /** Resource-protocol owner ID, derived from provider_id. Not persisted. */
  user_id?: string | null;
};
export type SubmitClaimResponse = {
  /** The claim with current status and annotations */
  claim: ClaimResponse3;
  /** True if blocked by validation/submission prechecks, False if submitted */
  submission_blocked: boolean;
};
export type BillingAddress5 = {
  /** Phone area code (3 digits) */
  area_code?: string | null;
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (optional) */
  line2?: string | null;
  /** Phone number (7 digits) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code */
  zip?: string | null;
};
export type ClaimLine5 = {
  /** Charge amount in cents (Box 24F) */
  charge_cents?: number | null;
  /** The claim this line belongs to. */
  claim_id?: string | null;
  /** CPT/HCPCS procedure code (Box 24D) */
  cpt_code?: string | null;
  /** Service date from (Box 24A) */
  date_from?: string | null;
  /** Service date to - optional for single date (Box 24A) */
  date_to?: string | null;
  /** Soft deletion timestamp */
  deleted_at?: string | null;
  /** Diagnosis pointers A-L (Box 24E) */
  diagnosis_pointers?: string[];
  /** Emergency indicator (Box 24C) */
  emg?: string | null;
  /** Encounter this line was billed from, if any. */
  encounter_id?: string | null;
  /** EPSDT Family Plan (Box 24H) */
  epsdt_family_plan?: string | null;
  /** Claim line ID (UUID). None until persisted. */
  id?: string | null;
  /** Line control number */
  line_control_number?: string | null;
  /** 1-based position of this line on the claim. */
  line_number?: number | null;
  /** CPT modifiers - max 4 (Box 24D) */
  modifiers?: string[];
  /** Place of service code override (Box 24B) */
  pos_code?: string | null;
  /** ID qualifiers (Box 24I) */
  qualifiers?: {
    [key: string]: any;
  } | null;
  /** Rendering provider NPI (Box 24J) */
  rendering_provider_npi?: string | null;
  /** Units of service (Box 24G) */
  units?: number | string;
};
export type InsuranceType5 =
  | "Medicare"
  | "Medicaid"
  | "TRICARE"
  | "CHAMPVA"
  | "GroupHealthPlan"
  | "FECA"
  | "Other";
export type Sex5 = "Male" | "Female";
export type ClaimStatus5 =
  | "draft"
  | "processing"
  | "scrubbing"
  | "ready"
  | "submitted"
  | "acknowledged"
  | "accepted"
  | "rejected"
  | "paid"
  | "partially_paid"
  | "denied"
  | "reversed"
  | "imported";
export type TaxIdType5 = "EIN" | "SSN";
export type SubmitClaimRequest = {
  /** Whether provider accepts assignment */
  accept_assignment?: boolean | null;
  /** Additional claim information (Designated by NUCC) (Box 19) */
  additional_claim_info?: string | null;
  /** Amount paid in cents */
  amount_paid_cents?: number | null;
  /** Balance due in cents */
  balance_due_cents?: number | null;
  /** Billing address */
  billing_address?: BillingAddress5 | null;
  /** Billing provider NPI (Box 33A, 10 digits) */
  billing_provider_npi?: string | null;
  /** Claim line items */
  claim_lines?: ClaimLine5[] | null;
  /** Date of current illness, injury, or pregnancy (Box 14) - YYYY-MM-DD format */
  date_current_illness_injury?: string | null;
  /** Date of same or similar illness (Box 15) - YYYY-MM-DD format */
  date_similar_illness?: string | null;
  /** Dates patient unable to work - from (Box 16) - YYYY-MM-DD format */
  date_unable_to_work_from?: string | null;
  /** Dates patient unable to work - to (Box 16) - YYYY-MM-DD format */
  date_unable_to_work_to?: string | null;
  /** ICD-10 diagnosis codes (max 12) */
  diagnoses?: string[] | null;
  /** Additional CMS-1500 box data */
  extra_boxes?: {
    [key: string]: any;
  } | null;
  /** Hospitalization dates related to current services - from (Box 18) - YYYY-MM-DD format */
  hospitalization_date_from?: string | null;
  /** Hospitalization dates related to current services - to (Box 18) - YYYY-MM-DD format */
  hospitalization_date_to?: string | null;
  /** Insurance company name for forms/display */
  insurance_payer_name?: string | null;
  /** Type of insurance (Box 1) - Medicare, Medicaid, TRICARE, CHAMPVA, GroupHealthPlan, FECA, Other */
  insurance_type?: InsuranceType5 | null;
  /** Original reference number (Box 22) */
  original_reference_number?: string | null;
  /** Other insured first name (Box 9) */
  other_insured_first_name?: string | null;
  /** Other insured last name (Box 9) */
  other_insured_last_name?: string | null;
  /** Other insured middle initial (Box 9) */
  other_insured_middle_initial?: string | null;
  /** Other insured's insurance plan or program name (Box 9d) */
  other_insured_plan_name?: string | null;
  /** Other insured's policy or group number (Box 9a) */
  other_insured_policy_number?: string | null;
  /** Outside lab? (Box 20) */
  outside_lab?: boolean | null;
  /** Outside lab charges in cents (Box 20) */
  outside_lab_charges?: number | null;
  /** Patient account number */
  patient_account_number?: string | null;
  /** Patient mailing address (Box 5) - {line1, line2, city, state, zip} */
  patient_address?: {
    [key: string]: any;
  } | null;
  /** Is condition related to auto accident? (Box 10b) */
  patient_condition_auto_accident?: boolean | null;
  /** State where auto accident occurred (Box 10b) */
  patient_condition_auto_accident_state?: string | null;
  /** Claim codes (Designated by NUCC) (Box 10d) */
  patient_condition_claim_codes?: string | null;
  /** Is condition related to patient's employment? (Box 10a) */
  patient_condition_employment_related?: boolean | null;
  /** Is condition related to other accident? (Box 10c) */
  patient_condition_other_accident?: boolean | null;
  /** Patient authorization signature on file (Box 12) */
  patient_consent_on_file?: boolean | null;
  /** Patient date of birth (Box 3) - YYYY-MM-DD format */
  patient_dob?: string | null;
  /** Patient first name (Box 2) */
  patient_first_name?: string | null;
  /** Patient last name (Box 2) */
  patient_last_name?: string | null;
  /** Patient middle initial (Box 2) */
  patient_middle_initial?: string | null;
  /** Patient sex (Box 3) - Male or Female */
  patient_sex?: string | null;
  /** Place of service code */
  place_of_service_code?: string | null;
  /** Primary insured address (Box 7) */
  primary_insured_address?: BillingAddress5 | null;
  /** Primary insured authorization signature on file (Box 13) */
  primary_insured_consent_on_file?: boolean | null;
  /** Primary insured date of birth (Box 11a) - YYYY-MM-DD format */
  primary_insured_dob?: string | null;
  /** Primary insured first name (Box 4) */
  primary_insured_first_name?: string | null;
  /** Primary insured's group number (Box 11) */
  primary_insured_group_number?: string | null;
  /** Is there another health benefit plan? (Box 11d) */
  primary_insured_has_other_plan?: boolean | null;
  /** Primary insured's ID number/policy number (Box 1a) */
  primary_insured_id_number?: string | null;
  /** Primary insured last name (Box 4) */
  primary_insured_last_name?: string | null;
  /** Primary insured middle initial (Box 4) */
  primary_insured_middle_initial?: string | null;
  /** Other claim ID (Designated by NUCC) (Box 11b) */
  primary_insured_other_claim_id?: string | null;
  /** Primary insured's insurance plan/program name (Box 11c) */
  primary_insured_plan_name?: string | null;
  /** Patient relationship to primary insured (Box 6) */
  primary_insured_relationship?: string | null;
  /** Primary insured sex (Box 11a) - Male or Female */
  primary_insured_sex?: Sex5 | null;
  /** Prior authorization number (Box 23) */
  prior_authorization_number?: string | null;
  /** Provider display name */
  provider_display_name?: string | null;
  /** Provider signature on file (Box 31) */
  provider_signature_on_file?: boolean | null;
  /** Name of referring provider or other source (Box 17) */
  referring_provider_name?: string | null;
  /** Referring provider NPI (Box 17b) */
  referring_provider_npi?: string | null;
  /** Resubmission code (Box 22) */
  resubmission_code?: string | null;
  /** Service start date */
  service_date_from?: string | null;
  /** Service end date */
  service_date_to?: string | null;
  /** Service facility information */
  service_facility?: {
    [key: string]: any;
  } | null;
  /** Service facility NPI number (Box 32a) */
  service_facility_npi?: string | null;
  /** Claim status */
  status?: ClaimStatus5 | null;
  /** Tax ID number */
  tax_id?: string | null;
  /** Tax ID type (EIN or SSN) */
  tax_id_type?: TaxIdType5 | null;
  /** Total charges in cents */
  total_charge_cents?: number | null;
};
